import { useMsal } from '@azure/msal-react'
import { faFile } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FileInput, Loader, Stack, Textarea } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { useState } from 'react'
import { FileWithUrl } from '../../models/FileWithUrl'
import { uploadBlobFromFile } from '../../utils/fileUtils'

interface PaidDesignConfigurationProps {
  setFiles: React.Dispatch<React.SetStateAction<FileWithUrl[]>>
  designNotes: string
  setDesignNotes: React.Dispatch<React.SetStateAction<string>>
}

function PaidDesignConfiguration(props: PaidDesignConfigurationProps) {
  const { setFiles, designNotes, setDesignNotes } = props
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { instance } = useMsal()

  const uploadDesignFiles = async (newFiles: File[]) => {
    setIsLoading(true)
    let files: FileWithUrl[] = []

    try {
      const uploadPromises = newFiles.map(async (file) => {
        const fileUrl = await uploadBlobFromFile(
          'advertisements',
          file,
          instance,
        )
        return { fileName: file.name, url: fileUrl }
      })

      files = await Promise.all(uploadPromises)
      setFiles(files)
    } catch (error) {
      notifications.show({
        title: 'An unknown error occurred',
        message: 'Unable to upload files. Please try again.',
        autoClose: false,
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Stack>
      <FileInput
        label='Files'
        description='Upload any relevant files for our designers to use (company logo, design files, etc.)'
        placeholder='Click to upload files'
        multiple={true}
        radius='md'
        clearable
        required={true}
        onChange={(val) => uploadDesignFiles(val)}
        leftSection={
          isLoading ? <Loader size='xs' /> : <FontAwesomeIcon icon={faFile} />
        }
      />
      <Textarea
        label='Notes'
        description='Please provide any details you would like to be included in your advertisement'
        resize='vertical'
        value={designNotes}
        styles={{ input: { fontSize: '16px' } }}
        onChange={(e) => setDesignNotes(e.target.value)}
        minRows={3}
        autosize
        required
        radius='md'
      />
    </Stack>
  )
}

export default PaidDesignConfiguration
